/**
 * Check whether a system has at least one matching Glue schedule.
 * Mirrors backend logic in _trigger_raw_stage.
 */
export function systemHasSchedule(entityName: string, systemName: string, systemAbbr: string | undefined, schedules: any[]): boolean {
    const entityLower = entityName.toLowerCase()
    const candidates = [systemName.toLowerCase()]
    if (systemAbbr) candidates.push(systemAbbr.toLowerCase())

    for (const schedule of schedules) {
        for (const jobAction of (schedule.job_actions || [])) {
            const args = jobAction.arguments || {}
            const jobEntity = (args['--entity_name'] || args['--entity_system'] || '').toLowerCase()
            if (jobEntity !== entityLower) continue

            const jobSystem = (args['--system_name'] || jobAction.job_name || '').toLowerCase()
            const jobName = (jobAction.job_name || '').toLowerCase()
            if (candidates.some(c => c === jobSystem || c === jobName)) return true
        }
    }
    return false
}
